import type { SymbolTypes } from '@racemap/utilities/consts/map';

export const IconInfoMapping: Record<SymbolTypes, { label: string; disabled?: boolean }> = {
  '1st-man': {
    label: 'First Man',
  },
  '1st-woman': {
    label: 'First Woman',
  },
  '2nd-man': {
    label: 'Second Man',
  },
  '2nd-woman': {
    label: 'Second Woman',
  },
  '3rd-man': {
    label: 'Third Man',
  },
  '3rd-woman': {
    label: 'Third Woman',
  },
  accomodation: {
    label: 'Accomodation',
  },
  'ambulance-moving': {
    label: 'Ambulance 1',
  },
  'ambulance-still': {
    label: 'Ambulance 2',
  },
  'black-spot': {
    label: 'Blackspot',
  },
  'broom-wagon': {
    label: 'Broomwagon',
  },
  'cut-off-deadline': {
    label: 'Cut Off',
  },
  'finish-01': {
    label: 'Finish 1',
  },
  'finish-02': {
    label: 'Finish 2',
  },
  'foto-section': {
    label: 'Fotopoint',
  },
  'information-point': {
    label: 'Informationpoint',
  },
  'man-empty': {
    label: 'Man',
  },
  parking: {
    label: 'Parking',
  },
  'police-moving': {
    label: 'Authority 1',
  },
  'police-still': {
    label: 'Authority 2',
  },
  'race-director-moving': {
    label: 'Referee 1',
  },
  'race-director-still': {
    label: 'Referee 2',
  },
  'refreshment-food': {
    label: 'Refreshment',
  },
  registration: {
    label: 'Registration',
  },
  shower: {
    label: 'Shower',
  },
  'split-times': {
    label: 'Splittimes',
  },
  'sprint-classification-01': {
    label: 'Sprint 1',
  },
  'sprint-classification-02': {
    label: 'Sprint 2',
  },
  'sprint-classification-03': {
    label: 'Sprint 3',
  },
  'sprint-empty': {
    label: 'Sprint',
    disabled: true,
  },
  'start-01': {
    label: 'Start 1',
  },
  'start-02': {
    label: 'Start 2',
  },
  'track-switch': {
    label: 'Trackswitch',
  },
  'transition-zone': {
    label: 'Transitionzone',
  },
  'turn-arrow-01': {
    label: 'Turn 1',
  },
  'turn-arrow-02': {
    label: 'Turn 2',
  },
  'uphill-classification-01': {
    label: 'Uphill Classification 1',
  },
  'uphill-classification-02': {
    label: 'Uphill Classification 2',
  },
  'uphill-classification-03': {
    label: 'Uphill Classification 3',
  },
  water: {
    label: 'Water',
  },
  WC: {
    label: 'WC',
  },
  'woman-empty': {
    label: 'Woman',
  },
};
